export class GuestProductPayment {
	bookingDetailsFound: boolean;
	bookingDetailsError: string;

	bookingId: string;
	checkIn: Date;
	checkOut: Date;
	listingDescription: string;

	hostName: string;

	paymentDate: Date;
	paymentStatus: string;
	amount: number;
	currencyIso: string;

	guestProductDisplayName: string;
}
